import React, { Fragment } from "react";
import OperatorTableGameEngineHelper from "../../../../Components/Info/HowGamesWork/TableGames/Index";

const OperatorTableGameEnginePage = () => {
  return <OperatorTableGameEngineHelper />;
}

export default OperatorTableGameEnginePage;